export default __webpack_public_path__ + "static/B0042-ba1d18adce57bddc2d4d1483ccb80d27.png";